<template>
  <div class="c-bitts-checkbox-group">
    <BittsFormLabel
      v-if="formLabel"
      :id="labelId"
      :label="formLabel"
      class="c-bitts-checkbox-group__label"
    />
    <div
      class="c-bitts-checkbox-group__content"
      role="group"
      :aria-labelledby="formLabel ? labelId : undefined"
    >
      <slot name="default" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useId } from 'vue';

import BittsFormLabel from '../BittsFormLabel/BittsFormLabel.vue';

interface Props {
  formLabel?: object | string;
}

withDefaults(defineProps<Props>(), { formLabel: '' });

const labelId = useId();
</script>

<style lang="pcss" scoped>
@reference "../../../../apps/crossbeam-app/src/css/theme.css";
.c-bitts-checkbox-group__content {
  @apply bg-white border-neutral-border border border-solid rounded-bts-md;
}

.c-bitts-checkbox-group__content:deep() .bitts-checkbox {
  @apply leading-6 px-12 py-8;
  .ant-checkbox-wrapper {
    @apply flex items-center leading-6;
  }
  .ant-checkbox {
    @apply m-0 pb-4;
  }
  &:not(:first-child) {
    @apply border-neutral-border border-t;
  }
  &:hover {
    @apply bg-neutral-background-disabled/24 bg-blend-overlay;
  }
  &:last-child {
    @apply rounded-b-bts-md;
  }
  &:first-child {
    @apply rounded-t-bts-md;
  }
}
</style>
